import { render, staticRenderFns } from "./MainGroupbuyingsCreateEditDetail.vue?vue&type=template&id=5a733e9f&"
import script from "./MainGroupbuyingsCreateEditDetail.vue?vue&type=script&lang=js&"
export * from "./MainGroupbuyingsCreateEditDetail.vue?vue&type=script&lang=js&"
import style0 from "./MainGroupbuyingsCreateEditDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports